// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M11.3333 25.3337V28.267C11.3333 28.6404 11.3333 28.827 11.2607 28.9697C11.1968 29.0951 11.0948 29.1971 10.9693 29.261C10.8267 29.3337 10.64 29.3337 10.2667 29.3337H7.73333C7.35997 29.3337 7.17328 29.3337 7.03067 29.261C6.90523 29.1971 6.80324 29.0951 6.73933 28.9697C6.66667 28.827 6.66667 28.6404 6.66667 28.267V25.3337M25.3333 25.3337V28.267C25.3333 28.6404 25.3333 28.827 25.2607 28.9697C25.1968 29.0951 25.0948 29.1971 24.9693 29.261C24.8267 29.3337 24.64 29.3337 24.2667 29.3337H21.7333C21.36 29.3337 21.1733 29.3337 21.0307 29.261C20.9052 29.1971 20.8032 29.0951 20.7393 28.9697C20.6667 28.827 20.6667 28.6404 20.6667 28.267V25.3337M4 16.0003H28M4 7.33366H28M8.66667 20.667H10.6667M21.3333 20.667H23.3333M10.4 25.3337H21.6C23.8402 25.3337 24.9603 25.3337 25.816 24.8977C26.5686 24.5142 27.1805 23.9023 27.564 23.1496C28 22.294 28 21.1739 28 18.9337V9.06699C28 6.82678 28 5.70668 27.564 4.85103C27.1805 4.09838 26.5686 3.48646 25.816 3.10297C24.9603 2.66699 23.8402 2.66699 21.6 2.66699H10.4C8.15979 2.66699 7.03969 2.66699 6.18404 3.10297C5.43139 3.48646 4.81947 4.09838 4.43597 4.85103C4 5.70668 4 6.82678 4 9.06699V18.9337C4 21.1739 4 22.294 4.43597 23.1496C4.81947 23.9023 5.43139 24.5142 6.18404 24.8977C7.03969 25.3337 8.15979 25.3337 10.4 25.3337Z"
    />
  </svg>
);
const IconBusCar = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconBusCar;
